// 광고·보상 버튼을 보여도 되는가 — 순수 함수 (prd/112 AC-030, INV-006)
// 닫는 조건이 하나라도 참이거나, 판정할 값을 하나라도 모르면 닫는다. 여는 길은 「전부 알고 전부 통과」 하나뿐이다
import type { AdGateSignals } from '../../../ports/ad-gate';

export interface GateConfig {
  /** AdSense 게시자 ID (ca-pub-…) */
  readonly client: string;
  /** 보상형 광고 단위 */
  readonly slot: string;
  /** 광고를 여는 국가. 비어 있으면 어디서도 띄우지 않는다 */
  readonly countries: readonly string[];
}

export const GATE_CLOSED_REASONS = ['no-countries', 'not-configured', 'adult-content', 'paid-user', 'consent-missing', 'country', 'unknown'] as const;

export type GateClosedReason = (typeof GATE_CLOSED_REASONS)[number];

export type GateDecision = { readonly open: true } | { readonly open: false; readonly reason: GateClosedReason };

const closed = (reason: GateClosedReason): GateDecision => ({ open: false, reason });

/** 앱 설정만으로 광고를 띄울 수 있는가 — 유저별 신호는 보지 않는다. decideGate 의 설정 단계와 같은 조건이다 */
export function isConfigured(config: GateConfig): boolean {
  return config.countries.length > 0 && config.client !== '' && config.slot !== '';
}

export function decideGate(config: GateConfig, signals: AdGateSignals): GateDecision {
  // 설정 — 국가 목록을 비우는 것이 끄는 스위치다. 되돌릴 때도 이 목록만 비운다
  if (config.countries.length === 0) return closed('no-countries');
  if (config.client === '' || config.slot === '') return closed('not-configured');
  // 신호 — 막는 값이 확인된 것부터
  if (signals.adultContentVisible === true) return closed('adult-content');
  if (signals.paidUser === true) return closed('paid-user');
  if (signals.consent === false) return closed('consent-missing');
  if (signals.country !== undefined && !config.countries.includes(signals.country)) return closed('country');
  // 하나라도 모르면 닫는다 (로딩·오류) — `=== false`·`=== true` 로만 통과시켜 undefined 가 새지 않게 한다
  if (signals.adultContentVisible !== false || signals.paidUser !== false || signals.consent !== true || signals.country === undefined) return closed('unknown');
  return { open: true };
}
